import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de7468b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-continer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://staff.risfond.com/static/images/logo-new3.png",
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "staff-info" }
const _hoisted_6 = { class: "staff-name" }
const _hoisted_7 = {
  key: 0,
  class: "staff-img"
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "header-img",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.jumpIndex && $setup.jumpIndex(...args)))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString($setup.personInfo.StaffName), 1)
        ]),
        ($setup.personImg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", { src: $setup.personImg }, null, 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}